<div class="p-x-24 p-t-24 p-b-16">
  <h2 mat-dialog-title class="p-0 m-b-16">{{ data.title | translate }}</h2>
  <mat-dialog-content class="mat-typography p-x-0">
    <p class="m-b-0">{{ data.message | translate }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="gap-8 p-x-0 p-t-16">
    <button type="button" mat-stroked-button class="text-white bg-primary"  (click)="cancel()">
      {{ data.cancelText | translate }}
    </button>
    <button type="button" mat-flat-button class="bg-error text-white" (click)="confirm()">
      {{ data.confirmText | translate }}
    </button>
  </mat-dialog-actions>
</div>
